import { Column, Columns, Flex, FormInput, PageHeaderTile, PrimaryButton, Toolbar } from 'lqx-react'
import * as React from 'react'


export const PaymentDetails = ({ payment }) => {

    return (
        <PageHeaderTile
            toolbar={
                <Toolbar>
                    <Flex grow />
                    <PrimaryButton>Resolve</PrimaryButton>
                </Toolbar>
            }
        >
            <Columns>
                <Column>
                    <FormInput label="Payer Name" value={ payment.payer.name } />
                    <FormInput label="Payer Company" value={ payment.payer.name } />
                </Column>
                <Column>
                    <FormInput label="Payee Name" value={ payment.payee.name } />
                    <FormInput label="Payee Company" value={ payment.payer.name } />
                </Column>
            </Columns>
        </PageHeaderTile>
    )
}